
import * as React from 'react';
import { Dialog, DialogType, DialogFooter, IDialogContentProps } from '@fluentui/react/lib/Dialog';
import { PrimaryButton, DefaultButton } from '@fluentui/react/lib/Button';
import { IModalProps } from '@fluentui/react/lib/Modal';

export interface IProps {
    dialogContentProps?: IDialogContentProps;
    modalProps?: IModalProps;
    onClose: () => void;
    onContinue: () => void;
    continueText?: string;
    cancelText?: string;
    children: React.ReactNode;
}

const defaultModelProps = {
    isBlocking: true,
    styles: { main: { maxWidth: 650 } },
};

const defaultDialogContentProps = {
    type: DialogType.largeHeader,
    title: '',
    subText: '',
};

// TODO replace/decommission this confirmationDialog, unify all confirmation dialogs
export const ConfirmationDialog = (props: IProps) => {

    return (
        <>
            <Dialog
                minWidth={800}
                hidden={false}
                onDismiss={props.onClose}
                dialogContentProps={{ ...defaultDialogContentProps, ...props.dialogContentProps }}
                modalProps={{ ...defaultModelProps, ...props.modalProps }}
            >
                {props.children}
                {(props.continueText || props.cancelText) &&
                    <DialogFooter>
                        <PrimaryButton onClick={props.onContinue} text={props.continueText} />
                        <DefaultButton onClick={props.onClose} text={props.cancelText} />
                    </DialogFooter>
                }
            </Dialog>
        </>
    );
};


